export class ODataPagedResult<T> {
  public data: T[] | undefined;
  public count: number | undefined;
  public nextLink: string | undefined;
}
